import { createContext } from "react";

export const EstimateTableSettingsContext = createContext(null);
